module.exports = "/images/vendor/flag-icon-css/flags/1x1/rs.svg?d00d37d2486026cb088d67ba2bb581d9";